// GET utilisation  Api
export const getUtilizationApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/utilizations/${queryString ? `?${queryString}` : ""}`;
};

// POST utilisation  Api
export const addUtilizationApi = (params) => {
    return `lease/${params?.leaseSlug}/utilizations/`;
};

// PUT edit utilisation  Api
export const updateUtilizationApi = (params) => {
    return `lease/${params?.leaseSlug}/utilizations/`;
};

// DELETE utilisation  Api
export const deleteUtilizationApi = (params) => {
    return `lease/utilizations`;
};
// Post File utilisation  Api
export const utilizationfileUploadApi = (slug) => {
    return `lease/utilizations/${slug}/attachments`;
};
export const utilizationTypeApi = () => {
    return `/lease/constants/get_by_constant_types`;
};
export const getAssetListApi=(query)=>{
    const queryString = new URLSearchParams({ ...query, include_on_wing: true, }).toString();
    return `/api/dropdown/asset/${queryString ? `?${queryString}` : ""}`
}
export const utilizationDetailApi = (params, startDate, endDate, utilizationType) => {
    if (utilizationType) {
        const query = { start_date: startDate, utilization_type: utilizationType?.label || "CTA Entry For Delivery" };
        if (endDate) query.end_date = endDate;
        const queryString = new URLSearchParams(query).toString();
        return `lease/${params?.leaseSlug}/initializations/${queryString ? `?${queryString}` : ""}`;
    }
    const query = { start_date: startDate };
    if (endDate) query.end_date = endDate;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/initializations/?${queryString}`;
};
//Details
export const utilizationDetailUpdateApi = (params, masterSlug) => {
     return `lease/${params?.leaseSlug}/utilizations/${masterSlug}/`;
};

export const getRegionEscalationApi = (params) => {
  return `lease/${params?.leaseSlug}/region_escalations?lite=true`;
};

export const getFleetUtilizationApi = (params, query) => {
    const { asset_id, ...rest } = query || {};
    const urlParams = new URLSearchParams();
  
    Object.entries(rest).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      urlParams.set(key, value);
    });
  
    let queryString = urlParams.toString();
    if (asset_id?.length) {
      const assetFilter = Array.isArray(asset_id) ? asset_id : asset_id.toString().split(',').filter(Boolean);
      const assetParam = `asset_id=[${assetFilter.join(',')}]`;
      queryString = queryString ? `${queryString}&${assetParam}` : assetParam;
    }
    return `lease/utilizations${queryString ? `?${queryString}` : ""}`;
};

// POST Trust Split  Api
export const addTrustSplitApi = (params) => {
    return `lease/${params?.leaseSlug}/utilizations/${params?.utilization_slug}/thrust-splits`;
};

// PUT Trust Split   Api
export const updateTrustSplitApi = (params) => {
    return `lease/${params?.leaseSlug}/utilizations/${params?.utilization_slug}/thrust-splits/${params?.thrust_split_slug}`;
};
 
// trust split dropdown Api
export const getEngineThrustApi = (engine_type_id) => {
    return `config/engine-types/?engine_family_engine_type=${engine_type_id}&for_thrust=${true}`;
}
